const minSuggestionHeight = 250;
const pageBotttomSpace = 16; //misto od spodniho okraje webu
const suggestionDivMargins = 16; //.search__results ma margn-top:8px,margin-bottom:8px;

$(document).ready(function () {
    $(window).on("resize scroll", function () {
        var suggestionDivs = selectNonPhoneSuggestionDivs();
        suggestionDivs.each(function (index, suggestionDiv) {
            setSuggestionHeight(suggestionDiv);
        });
    });

    $(document).on("ajaxComplete", function () {
        var suggestionDivs = selectNonPhoneSuggestionDivs();
        suggestionDivs.each(function (index, suggestionDiv) {
            setSuggestionHeight(suggestionDiv);
        });
    });

});

function setSuggestionHeight(_suggestionDiv) {
    var suggestionDiv = $(_suggestionDiv);
    var showAllResultsBtnHeight = suggestionDiv.find('.search__button__wrapper').height() == 'undefined' ? 72 : suggestionDiv.find('.search__button__wrapper').height();
    var maxSuggestionHeight = $(window).innerHeight() - suggestionDivMargins - showAllResultsBtnHeight;

    if (suggestionDiv.is(':visible')) {
        var suggestionHeight;
        suggestionHeight = $(window).innerHeight() + $(window).scrollTop() - suggestionDiv.offset().top - suggestionDivMargins - showAllResultsBtnHeight;
        if (suggestionDiv.attr('id') !== 'suggestionsHeadPhoneSearch') {
            suggestionHeight = suggestionHeight - pageBotttomSpace;
        }
        if (suggestionHeight > maxSuggestionHeight) {
            suggestionHeight = maxSuggestionHeight;
        } else if (suggestionHeight < minSuggestionHeight) {
            suggestionHeight = minSuggestionHeight;
        }

        suggestionDiv.find('.search__results').css({
            'max-height': `${suggestionHeight}px`,
        });
    }
}

function selectNonPhoneSuggestionDivs() {
    var suggestionIDs = [
        '#suggestionsHeadPhoneSearch',
        '#suggestionsHeadSearch',
        '#suggestionIndex',
        '#suggestionConfigurator',
        //'#search-result-suggestions' //tiskarny vypadaji blbe, protoze jsou ve spodu stranky, cimz ji roztahuji a lepi se to az ke spodnimu okraji
    ];

    var suggestionDivs = $(suggestionIDs.join(','));
    return suggestionDivs;
}
